import CarouselDots from './CarouselDots'

export type { CarouselDotsProps } from './CarouselDots'

export default CarouselDots
